import React, { FC } from 'react';
import cls from 'classnames';
import { ChipChoiceProps } from './ChipChoice.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { CaretDownBoldIcon, CaretUpBoldIcon } from '@stashinvest/react-assets';

export const classNames = getClassNames('sds-chip-choice', ['is-active', 'is-enabled']);

const ChipChoice: FC<ChipChoiceProps> = (props) => {
	const { className, onClick, text, isEnabled = true, isActive = false, label } = props;

	function renderIcon() {
		if (!isActive)
			return (
				<CaretDownBoldIcon
					color={isEnabled ? 'text-onSurfaceVariant' : undefined}
					size="2XS"
				/>
			);
		else
			return (
				<CaretUpBoldIcon
					color={isEnabled ? 'text-onSurfaceVariant' : undefined}
					size="2XS"
				/>
			);
	}
	
	return (
		<button
			disabled={!isEnabled}
			onClick={onClick}
			className={cls(getRootClassListFromProps(classNames, props), className, {
				[classNames.isActive]: isActive,
			})}
			data-testid={props['data-testid']}
			aria-label={label}
		>
			<span>{text}</span>
			{renderIcon()}
		</button>
	);
}

ChipChoice.displayName = 'ChipChoice';

export default ChipChoice;
